import styled from "styled-components/macro";
import { TextProps } from "../types";
import { getTextAlign } from "./helpers";
import { getCommonProps, collectTypographyStyles } from "../../../types";
import { IndicatorStyles } from "..";
import Icon from "../../Icon";
import { useLink } from './useLink'

export const TertiaryWrapper = styled.span<TextProps>`
    ${(props) => getTextAlign(props)};
    ${(props) => ({
        ...props.theme.typography.small,
        color: props.theme.colors.text.tertiary,
        ...props.styles,
    })};
    ${(props) => getCommonProps(props)};
    ${(props) => collectTypographyStyles(props)};
    ${(props) => (props.color ? { color: props.color } : {})};
    transition: ${props => props.noTransition ? "none" : "all 200ms ease-in"};
`;

export default function Tertiary (props: TextProps) {
    const { navigate } = useLink();

    return <TertiaryWrapper {...props} onClick={props.onClick ?? navigate(props.link)}>
        {props.children}
        {props.withIndicator && <Icon name="color-indicator" styles={IndicatorStyles}/>}
    </TertiaryWrapper>
}